import { TransactionType } from "../../shared/Consts";
import { IAddHoldingProps } from "./IAddHolding"
import { useState } from "react";
import Utils from "../../portlibs/PortUtils";
import EvalText, { TOnEval } from "../../components/EvalText";
import FormGroup from "../../libs/form/FormGroup";

interface IUsePriceProps {
    price:string;
    setPrice:TOnEval;
    settle:string;
    setSettle:TOnEval;
}
interface ITransPriceProps extends IAddHoldingProps, IUsePriceProps {
    type:TransactionType
    form:FormGroup;
    controlName:string
}
export function usePrice(props:IAddHoldingProps) : IUsePriceProps {
    const {transaction,holding,type} = props;
    const defaultPrice = type===TransactionType.dividend ? "1" : transaction?.price.toString() || holding?.currentPrice.toString() || "1"
    const [price,setPrice] = useState<string>(defaultPrice);
    const [settle,setSettle] = useState<string>("");
    return {price,setPrice,settle,setSettle}
}
export default function TransPrice(props:ITransPriceProps) {
    return <div className="flex gap-8">
        <EvalText placeholder="Price" onEval={props.setPrice} value={props.price} 
            onChange={(e)=>props.setPrice(e.target.value)} disabled={Utils.isCashAction(props.type)}
            form={props.form} controlName={props.controlName}/>
        <EvalText placeholder="Settlement (C$)" onEval={props.setSettle} value={props.settle} onChange={(e)=>props.setSettle(e.target.value)}/>
    </div>
}